import React, { Component, Fragment } from "react";
import '../assets/css/font-awesome.min.css';
import '../assets/fonts/fonts.css';
import './Custom.css';
import aboutImage from '../assets/images/kicksfinder-about-banner.png';
import * as APICONST from '../constants/Api';
import axios from 'axios';
import * as COMMONCONST from '../constants/Common';


class About extends Component {
    constructor() {
        super()
        this.state = {
            name: '',
            email: '',
            subject: '',
            country: 'United States',
            message: '',
            errors: {
                name: '',
                email: '',
                subject: '',
                message: '',
                country: ''
            },
            success_message: '',
            countryList: [],
            isLoading: false,
        }
        this.handleFormSubmit = this.handleFormSubmit.bind(this)
        this.setBlankError = this.setBlankError.bind(this)
    }

    componentDidMount() {
        axios({
            method: "get",
            url: APICONST.COUNTRYLIST,
            headers: { "content-type": "application/json" },
            params: {}
        })
            .then(response => {
                if (response.data.result.countries) {
                    this.setState({ countryList: response.data.result.countries })
                }
            })
            .catch(error => {
            });
    }
    setBlankError = e => {
        this.setState({
            errors: {
                name: '',
                email: '',
                subject: '',
                message: '',
                country: 'United States'
            }
        })

    }

    handleFormSubmit = e => {
        e.preventDefault();
        
        this.validateName();
        this.validateEmail();
        this.validateSubject();
        this.validateMessage();
        
        let tagErrors = this.state.errors;

        if (
            this.state.name !== '' &&
            this.state.email !== '' &&
            this.state.subject !== '' &&
            this.state.message !== '' &&
            this.state.tagError !== true
        ) {
            this.setState({
                isLoading: true
            });
    
            axios({
                method: 'post',
                url: APICONST.CONTACT_US,
                headers: { 'content-type': 'application/json' },
                data: this.state
            })
            .then(response => {

                if (
                    typeof response.data !== 'undefined' &&
                    typeof response.data.result.message !== 'undefined'
                ) {
                    this.setState({
                      success_message: response.data.result.message
                    })
                 }

                this.setState({ error: false, isLoading: false })

                this.setState({
                    name: '',
                    email: '',
                    subject: '',
                    message: '',
                    country: 'United States'
                })
                this.setBlankError();
            })
            .catch(error => {
                this.setState({ isLoading: false });
                if (error.response.data.result.error.message) {
                    tagErrors.message = error.response.data.result.error.message;
                }
                if (error.response.data.result.error.name) {
                    tagErrors.name = error.response.data.result.error.name;
                }
                if (error.response.data.result.error.email) {
                    tagErrors.email = error.response.data.result.error.email;
                }
                if (error.response.data.result.error.country) {
                    tagErrors.country = error.response.data.result.error.country;
                }
                if (error.response.data.result.error.subject) {
                    tagErrors.subject = error.response.data.result.error.subject;
                }
                if (error.response.data.result.error) {
                    this.setState({
                        tagErrors,
                        tagError: false
                    })
                }
            })
        }
    }

    validateName = () => {
        let name = this.state.name;
        let isError = false;
        const ValidName = RegExp(
            /^[a-zA-Z0-9 ]*$/i
        )
        
        let tagErrors = this.state.errors;
        if ('' === name) {
            tagErrors.name = 'Please enter your name'
            isError = true;
            this.setState({
                tagErrors,
                tagError: true
            })
        } else if (name && ValidName.test(name) === false) {
            tagErrors.name = 'Name not allow special characters'
            isError = true;
            this.setState({
                tagErrors,
                tagError: true
            })
        } else {
            tagErrors.name = ''
            this.setState({
                tagErrors,
                tagError: false
            })
        }

        if (isError === true) {
            return false;
        }
    }

    validateEmail = () => {
        let email = this.state.email;
        let isError = false;

        const validEmailRegex = RegExp(
            /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
        )
        
        let tagErrors = this.state.errors;
    
        if ('' === email) {
            tagErrors.email = 'Please enter an email address'
            isError = true;
            this.setState({
                tagErrors,
                tagError: true
            })
        } else if (email && validEmailRegex.test(email) === false) {
            tagErrors.email = 'Email is not valid'
            isError = true;
            this.setState({
                tagErrors,
                tagError: true
            })
        } else {
            tagErrors.email = ''
            this.setState({
                tagErrors,
                tagError: false
            })
        }
    
        if (isError === true) {
            return false;
        }
    }

    validateSubject = () => {
        let subject = this.state.subject;
        let isError = false;
    
        let tagErrors = this.state.errors;
    
        if ('' === subject) {
            tagErrors.subject = 'Please enter subject'
            isError = true;
            this.setState({
                tagErrors,
                tagError: true
            })
        } else {
            tagErrors.subject = ''
            this.setState({
                tagErrors,
                tagError: false
            })
        }
    
        if (isError === true) {
            return false;
        }
    }

    validateMessage = () => {
        let message = this.state.message;
        let isError = false;
    
        let tagErrors = this.state.errors;
    
        if ('' === message) {
            tagErrors.message = 'Please enter message'
            isError = true;
            this.setState({
                tagErrors,
                tagError: true
            })
        } else {
            tagErrors.message = ''
            this.setState({
                tagErrors,
                tagError: false
            })
        }
    
        if (isError === true) {
            return false;
        }
    }

    render() {

        let aboutTitle = (
            <svg width="215" height="43" viewBox="0 0 215 43" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30.3438 1.41406H21.2054L14.6434 17.881H13.6504L17.1648 1.41406H8.72654L0 42.2962H8.43367L12.0671 25.2407H13.0646L12.5338 42.2962H22.084L21.146 21.3852L30.3438 1.41406Z" fill="black" /><path d="M31.6891 1.41406L22.9626 42.2962H31.3963L40.1228 1.41406H31.6891Z" fill="black" /><path d="M48.9089 24.4245L46.8588 33.8876C46.6254 34.7637 45.9207 35.3477 45.0421 35.3477C44.104 35.3477 43.6372 34.7637 43.8111 33.8876L48.9638 9.82371C49.1377 8.94767 49.9019 8.36364 50.7805 8.36364C51.6591 8.36364 52.1853 8.94767 51.9519 9.82371L50.1352 18.7028H58.5735L60.3902 9.82371C61.6211 4.33473 58.3996 0.711914 52.4233 0.711914C46.4469 0.711914 41.7062 4.33473 40.5347 9.82371L35.3775 33.8876C34.2655 39.3766 37.4275 42.9994 43.4039 42.9994C49.3802 42.9994 54.1256 39.3766 55.297 33.8876L57.3471 24.4245H48.9089Z" fill="black" /><path d="M85.9887 1.41406H76.8503L70.2882 17.881H69.2906L72.8051 1.41406H64.3714L55.6448 42.2962H64.0785L67.7119 25.2407H68.7049L68.1787 42.2962H77.7289L76.7908 21.3852L85.9887 1.41406Z" fill="black" /><path d="M91.608 13.7385L92.4866 9.70964C92.6605 8.89291 93.3057 8.3682 94.1248 8.3682C95.0034 8.3682 95.4153 8.89291 95.2963 9.70964L94.0653 15.1439H102.504L103.675 9.82828C104.847 4.33473 101.684 0.711914 95.7676 0.711914C89.8508 0.711914 85.2244 4.33473 83.9934 9.82371L82.9409 14.7287C80.9504 24.1325 92.1388 24.9492 91.2007 29.2701L90.2031 33.8831C90.0293 34.7591 89.2651 35.3431 88.3865 35.3431C87.5078 35.3431 86.9816 34.7591 87.215 33.8831L88.5054 27.8694H80.0718L78.7813 33.8831C77.6098 39.372 80.7719 42.9949 86.7482 42.9949C92.7246 42.9949 97.4653 39.372 98.6414 33.8831L99.8723 28.2161C101.858 18.8762 90.7294 18.0001 91.608 13.7385Z" fill="black" /><path d="M117.614 17.881H112.342L114.218 9.06578H120.135L121.773 1.41406H107.423L98.6963 42.2962H107.13L110.763 25.2407H116.035L117.614 17.881Z" fill="black" /><path d="M123.471 1.41406L114.745 42.2962H123.178L131.905 1.41406H123.471Z" fill="black" /><path d="M147.665 1.41406L144.265 17.1829L143.738 22.9639H142.8L143.327 17.1829L143.565 1.41406H134.307L125.581 42.2962H134.014L137.355 26.5274L137.941 20.7464H138.879L138.293 26.5274L138.115 42.2962H147.372L156.098 1.41406H147.665Z" fill="black" /><path d="M168.925 1.41406H158.441L149.715 42.2962H160.199C165.822 42.2962 170.334 38.8514 171.446 33.7092L176.485 9.99658C177.592 4.85893 174.549 1.41406 168.925 1.41406ZM167.927 10.5213L163.123 33.1844C162.949 34.0605 162.185 34.6445 161.306 34.6445H159.782L165.228 9.06122H166.751C167.635 9.06578 168.161 9.64525 167.927 10.5213Z" fill="black" /><path d="M183.861 25.2407H189.133L190.712 17.881H185.44L187.316 9.06578H193.233L194.871 1.41406H180.521L171.794 42.2962H186.145L187.783 34.6445H181.871L183.861 25.2407Z" fill="black" /><path d="M207.405 1.41406H196.688L187.961 42.2962H196.395L199.617 27.2255H200.962L200.202 42.2962H208.636L209.048 25.0673C210.924 23.6666 212.269 21.6225 212.796 19.1084L214.786 9.76388C215.843 4.7403 212.915 1.41406 207.405 1.41406ZM206.174 10.5213L204.476 18.5837C204.303 19.519 203.538 20.1031 202.66 20.1031H201.136L203.479 9.06578H205.003C205.881 9.06578 206.412 9.64525 206.174 10.5213Z" fill="black" /> </svg>
        )

        return (
            <div className='App'>
                <div className="cms-page about-us-page cms-column-layout">
                    <div className="container">
                        <div className="cms-cnt-inner">
                            <div className="cms-img-conatiner">
                                <img src={aboutImage} alt="about" className="d-block w-100" />
                            </div>
                            <div className="cms-cnt-wrapper">
                                <div className="cms-row">
                                    <div className="cms-col">
                                        <h4 className="cms-page-title">About</h4>
                                        <div className="about-title">{aboutTitle}</div>
                                    </div>
                                    <div className="cms-col">
                                        <div className="cms-cnt-txt">
                                            <p>Kicksfinder began in 2005 as a visual tool to browser the ebay sneaker selection. We are bringing it back with new tools for todays market.</p>
                                            <p>Kicksfinder is an online database of the most popular sneakers from Nike, Jordan, Yeezy, adidas, and other footwear brands. Find a full list retailers as well as release dates, prices, and more.</p>
                                        </div>
                                    </div>
                                    <div className="cms-col">
                                        <div className="cms-cnt-form">
                                            <h4 className="cms-page-title">Contact</h4>
                                            <form id="about" className={`row ${this.state.isLoading ? 'loader-active' : ''}`} onSubmit={this.handleFormSubmit}>
                                                <div className="col-md-6">
                                                    <label>Name<span>*</span></label>
                                                    <div className="form-field-wrp kf-focus kf-clear">
                                                        <input type='text' name='name' className="form-field" value={this.state.name} placeholder='Name'
                                                            onChange={e => {
                                                                this.setState({
                                                                    name: e.target.value
                                                                }, () => this.validateName())
                                                            }} 
                                                        />
                                                        {this.state.name && 
                                                            <span 
                                                                className="kf-clear-span" 
                                                                onClick={e => {
                                                                    this.setState({ name: '' })
                                                                }}
                                                            >
                                                            </span>
                                                        }
                                                    </div>
                                                    {this.state.errors.name ? (
                                                        <span className='errorMsg'>
                                                            <i className='alert-icon fa fa-exclamation'></i>
                                                            {this.state.errors.name}
                                                        </span>
                                                    ) : (
                                                        ''
                                                    )}
                                                </div>
                                                <div className="col-md-6">
                                                    <label>Email Address<span>*</span></label>
                                                    <div className={`form-field-wrp kf-focus kf-clear ${this.state.email.length <= 0 || this.state.errors.email ? 'kf-negative' : 'kf-positive'}`}>
                                                        <input type='text' name='email' className="form-field" value={this.state.email} placeholder='Email Address'
                                                            onChange={e =>
                                                                this.setState({
                                                                    email: e.target.value
                                                                }, () => this.validateEmail())
                                                            }
                                                        />
                                                        {this.state.email && 
                                                            <span 
                                                                className="kf-clear-span" 
                                                                onClick={e => {
                                                                    this.setState({ email: '' });
                                                                }}
                                                            >
                                                            </span>
                                                        }
                                                    </div>
                                                    {this.state.errors.email ? (
                                                        <span className='errorMsg'>
                                                            <i className='alert-icon fa fa-exclamation'></i>
                                                            {this.state.errors.email}
                                                        </span>
                                                    ) : (
                                                        ''
                                                    )}
                                                </div>
                                                <div className="col-md-6">
                                                    <label>Subject<span>*</span></label>
                                                    <div className="form-field-wrp kf-focus kf-clear">
                                                        <input type='text' name='subject' className="form-field" value={this.state.subject} placeholder='Subject'
                                                            onChange={e =>
                                                                this.setState({
                                                                    subject: e.target.value
                                                                }, () => this.validateSubject())
                                                            }
                                                        />
                                                        {this.state.subject && 
                                                            <span 
                                                                className="kf-clear-span" 
                                                                onClick={e => {
                                                                    this.setState({ subject: '' })
                                                                }}
                                                            >
                                                            </span>
                                                        }
                                                    </div>
                                                    {this.state.errors.subject ? (
                                                        <span className='errorMsg'>
                                                            <i className='alert-icon fa fa-exclamation'></i>
                                                            {this.state.errors.subject}
                                                        </span>
                                                    ) : (
                                                        ''
                                                    )}
                                                </div>
                                                <div className="col-md-6">
                                                    <label>Country</label>
                                                    <div className="select-data">
                                                        <select name='country' value={this.state.country}
                                                            onChange={e =>
                                                                this.setState({ country: e.target.value })
                                                            }>
                                                            {this.state.countryList.length > 0 ? <>
                                                                {this.state.countryList.map((country, ind) =>
                                                                    <option key={ind} value={country.name}>{country.name}</option>
                                                                )}
                                                            </> : ''}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <label>Message<span>*</span></label>
                                                    <div className="form-field-wrp kf-focus kf-clear">
                                                        <textarea rows='5' name='message' className="form-field" value={this.state.message} placeholder='Message'
                                                            onChange={e =>
                                                                this.setState({
                                                                    message: e.target.value
                                                                }, () => this.validateMessage())
                                                            }></textarea>
                                                        {this.state.message && 
                                                            <span 
                                                                className="kf-clear-span"
                                                                onClick={e => {
                                                                    this.setState({ message: '' })
                                                                }}
                                                            >
                                                            </span>
                                                        }
                                                    </div>
                                                    {this.state.errors.message ? (
                                                        <span className='errorMsg'>
                                                            <i className='alert-icon fa fa-exclamation'></i>
                                                            {this.state.errors.message}
                                                        </span>
                                                    ) : (
                                                        ''
                                                    )}

                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="about-label-button">
                                                        <p><span>*</span>Required</p>
                                                        <button className={`loader-btn`} type='submit' name='subject'>Submit</button>
                                                    </div>
                                                </div>
                                                {this.state.success_message ? (
                                                    <div className='col-lg-12'>
                                                        <div className='userMsgSuccess'>
                                                        <p><i className="success-icon fa fa-check-circle" ></i>{this.state.success_message}</p>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

export default About